<div class="fm-ikea-container">
  <div class="fm-ikea-row justify-content-center">
    <div class="fm-ikea-col-md-6 fm-ikea-col-12">
      <form [formGroup]="formGroup" (ngSubmit)="submitAgreement()">
        <h1>We need your consent</h1>

        <p class="margin-bottom-xs">
          Please read and accept the terms below to access IKEA Media Content
          Centre.
        </p>

        <ul class="margin-bottom-m">
          <li class="margin-bottom-xs">
            As an external IKEA partner with access to IKEA Media Content
            Centre, I will treat any information received from Inter IKEA
            Systems B.V., its franchisees or any company operating under the
            IKEA trademark as strictly confidential and shall use such
            information solely for the purpose of performing the agreed
            assignment and not for any other purpose. Any unauthorised use of
            confidential information may result in an obligation to pay damages.
          </li>

          <li class="margin-bottom-xs">
            I am responsible for ensuring that my account name and account
            password are not copied, surrendered or disclosed to any other
            person. Upon completion or termination of the agreed assignment or
            commission any and all information or documentation still in my
            possession shall be destroyed, permanently erased or returned to
            Inter IKEA Systems B.V.
          </li>

          <li class="margin-bottom-xs">
            Upon loss of the account name or account password or other
            confidential/internal information, I will inform the IMCC team
            immediately at
            <a href="mailto:support@imcc.systems.com"
              >support@imcc.systems.com</a
            >.
          </li>
        </ul>

        <app-checkbox class="margin-bottom-s d-block">
          I agree to the terms above as part my access to IKEA Media Content
          Centre.
          <input
            type="checkbox"
            [formControl]="acceptTermsCheckbox"
            (change)="toggleAcceptance()"
          />
        </app-checkbox>

        <small class="d-block margin-bottom-s">
          * The personal information we store about users in IMCC is name,
          company name, city, country and email address. This information is
          deleted 6 months after the user’s access rights are removed. IMCC also
          store usage logs. After the user information has been deleted, the
          usage logs become anonymous and can’t be tracked back to the user.
        </small>

        <div>
          <button
            class="fm-btn fm-btn--filled"
            [disabled]="!(acceptedTerms$ | async)"
          >
            Confirm and start browsing
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
